// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "container-3yUB7";
var _4 = "type_account-3stEO";
var _5 = "preview-2sPPG";
var _6 = "root-2BD2P";
var _7 = "type_review-2JWBM";
var _8 = "orderPreview-2eK_v";
var _9 = "link-1k_lj";
var _a = "button-NAd3e";
var _b = "status-103Pl";
var _c = "payload-27ot2";
var _d = "paper-1ftEY";
var _e = "button_checkin-3V_05";
var _f = "paymentStatus-3P21-";
var _10 = "orderStatus-3DKK4";
var _11 = "paymentStatusIcon-1eEYX";
var _12 = "passengers-2cm76";
var _13 = "buttons-1pY4j";
var _14 = "booking-1pVIQ";
export { _1 as "__esModule", _2 as "mobile", _3 as "container", _4 as "type_account", _5 as "preview", _6 as "root", _7 as "type_review", _8 as "orderPreview", _9 as "link", _a as "button", _b as "status", _c as "payload", _d as "paper", _e as "button_checkin", _f as "paymentStatus", _10 as "orderStatus", _11 as "paymentStatusIcon", _12 as "passengers", _13 as "buttons", _14 as "booking" }
export default { "__esModule": _1, "mobile": _2, "container": _3, "type_account": _4, "preview": _5, "root": _6, "type_review": _7, "orderPreview": _8, "link": _9, "button": _a, "status": _b, "payload": _c, "paper": _d, "button_checkin": _e, "paymentStatus": _f, "orderStatus": _10, "paymentStatusIcon": _11, "passengers": _12, "buttons": _13, "booking": _14 }
